import { MEDIA_TYPE_LABELS, STATUS_LABELS, type Status } from '@mass-cult/shared';
import { Cell, Placeholder } from '@telegram-apps/telegram-ui';
import { Link } from 'react-router-dom';
import { resolveImageUrl } from '../shared/api/client';

interface PosterProps {
  url: string | null;
  alt: string;
  className?: string;
}

export function Poster({ url, alt, className }: PosterProps) {
  const resolvedUrl = resolveImageUrl(url);

  if (!resolvedUrl) {
    return (
      <div
        className={className}
        style={{
          background: 'var(--tg-theme-secondary-bg-color, #eee)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'var(--tg-theme-hint-color, #999)',
          fontSize: 12,
        }}
      >
        Нет постера
      </div>
    );
  }

  return <img src={resolvedUrl} alt={alt} className={className} />;
}

export function EmptyState({ title, description }: { title: string; description?: string }) {
  return <Placeholder header={title} description={description} />;
}

export function ErrorState({ message }: { message: string }) {
  return <Placeholder header="Ошибка" description={message} />;
}

export function TitleListItem({
  mediaType,
  tmdbId,
  title,
  subtitle,
  posterUrl,
  rating,
  status,
}: {
  mediaType: 'movie' | 'tv';
  tmdbId: number;
  title: string;
  subtitle?: string;
  posterUrl: string | null;
  rating?: number | null;
  status?: Status | null;
}) {
  return (
    <Link to={`/title/${mediaType}/${tmdbId}`} style={{ textDecoration: 'none', color: 'inherit' }}>
      <Cell
        before={
          <Poster
            url={posterUrl}
            alt={title}
            className="poster-thumb"
          />
        }
        subtitle={subtitle}
        after={rating ? `${rating}/10` : undefined}
      >
        {title}
        {status ? ` · ${STATUS_LABELS[status]}` : ''} · {MEDIA_TYPE_LABELS[mediaType]}
      </Cell>
    </Link>
  );
}
